import { useImageSrc } from "../../hooks/useImage";
import { Image, Typography, Tag } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useClassRequiredItems } from "../../api/Classes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faClock } from "@fortawesome/free-regular-svg-icons";
import { useUser } from "../../api/Users";

import "./ClassDisplay.css";
import UserDisplay from "../UserDisplay";

const ClassDisplay = ({ course }) => {
  const imgSrc = useImageSrc(course?.CoverImage);

  return (
    <div className="class-details">
      <div className="class-detail-section">
        <Image src={imgSrc} preview={false} />
      </div>
      <div className="class-detail-section">
        <ClassTitle course={course} />
      </div>
      <div className="class-detail-section">
        <ClassMeta course={course} />
      </div>
      <div className="class-detail-section">
        <ClassDetails course={course} />
      </div>
    </div>
  );
};

/*
	CourseId: "01GPBZM31HDV0TZE59MMBN6FW3",
	UserId: "37bdaf4a-b0c6-451f-9088-9ed3ac7c69c6",
	Name: "This is a fake class",
	StartTime: "2023-01-30T19:00:49Z",
	EndTime: "2023-01-30T20:00:49Z",
	Description:
		"In this fake class we will do fake things. Feel free to bring your fake friends as well! ",
	
		Limit: 10,
	RegistrantCount: 0,
	RegistrationDeadline: "2023-01-23T19:19:57.134Z",
	RequireShipping: false,
	Cost: 250,
	BillingType: "PerRegistrant",
	
	Approved: true,
	OrganizationId: "none",
	CoverImage: "courseCoverImage/01GPBZM31HDV0TZE59MMBN6FW3/smp-trivia.jpg",
	ImageName: "smp-trivia.jpg",
	HostUser: "37bdaf4a-b0c6-451f-9088-9ed3ac7c69c6",
	Tags: ["Fake", "Not Real"],
*/
const ClassTitle = ({ course }) => {
  return (
    <>
      <div className="class-title">
        <Typography.Title level={1}>{course?.Name}</Typography.Title>
        <Typography.Text>
          {course?.Tags?.map((t) => (
            <Tag key={t}>{t}</Tag>
          ))}
        </Typography.Text>
      </div>
    </>
  );
};

const ClassMeta = ({ course }) => {
  const [hostUser, setHostUser] = useState();
  let startTime = dayjs(course?.StartTime),
    endTime = dayjs(course?.EndTime);
  let duration = endTime.diff(startTime, "minutes");

  const { data } = useUser(course?.HostUser);

  useEffect(() => {
    if (data?.User) setHostUser(data.User);
  }, [data]);

  return (
    <>
      {hostUser && (
        <UserDisplay
          user={hostUser}
          size={30}
          style={{ marginBottom: "10px" }}
        />
      )}
      <Typography.Text>
        <FontAwesomeIcon icon={faCalendar} /> {startTime.format("MMM Do")}{" "}
        <FontAwesomeIcon icon={faClock} /> {duration} minutes
      </Typography.Text>
    </>
  );
};

const ClassDetails = ({ course }) => {
  return (
    <>
      <Typography.Title level={5} type="secondary">
        What you'll learn:
      </Typography.Title>
      <Typography.Paragraph>{course?.Description}</Typography.Paragraph>
      <ClassRequiredItems courseId={course?.CourseId} />
    </>
  );
};

const ClassRequiredItems = ({ courseId }) => {
  const [items, setItems] = useState([]);

  const { data } = useClassRequiredItems(courseId);

  useEffect(() => {
    if (data?.requiredItems) {
      setItems(data.requiredItems);
    }
  }, [data]);
  return items.length > 0 ? (
    <>
      <Typography.Title level={5} type="secondary">
        What you will need:
      </Typography.Title>
      <ul>
        {items?.map((i) => (
          <li key={i.ItemId}>
            {i.Quantity} x {i.ItemName}
          </li>
        ))}
      </ul>
    </>
  ) : null;
};

export default ClassDisplay;
